import {
	usageMap,
	goalMap,
	featureMap,
	emailProviders,
} from '@/wizard/data'

import { mapState, mapGetters, mapActions } from 'vuex'

export const screen = {
	data () {
		return {
			usageMap,
			goalMap,
			featureMap,
			emailProviders,
		}
	},
	mounted () {
		this.$bus.$on('onboardingCanNextPage', this.canNextPage)
	},
	beforeDestroy () {
		this.$bus.$off('onboardingCanNextPage', this.canNextPage)
	},
	computed : {
		...mapGetters([
			'onboardingVia',
			'onboardingGoal',
			'onboardingUsage',
			'onboardingUsageOtherText',
			'onboardingEmailList',
			'onboardingEmailService',
			'onboardingEmailServiceOtherText',
		]),
		...mapState('wizard', [
			'extraFeatures',
		]),
		...mapGetters('wizard', [
			'getGoal',
			'getUsage',
		]),
		isDisabled () {
			return false
		},
		wpOnboarding () {
			return 'wordpress' === this.onboardingVia
		},
	},
	methods : {
		...mapActions('wizard', [ 'skip' ]),
		canNextPage (proceed) {
			if (this.isDisabled) {
				proceed.canProceed = false
			}
		},
		setBoolVal (event) {
			let { name, value } = event.target
			value = '1' === value || 1 === value
			this.setValue({ target: { name, value } })
		},
		setValue (event) {
			this.$store.commit('setUserAttribute', {
				key   : `onboarding.${event.target.name}`,
				value : event.target.value,
			})
		},
		mapToRadios (data, pageSetting) {
			return data.map(t => ({
				label   : t.title,
				value   : t.slug,
				checked : t.slug === this[pageSetting],
			}))
		},
	},
}
